import React, { Component } from "react";
import MessageConfirmations from "./MessageConfirmations";

class SentMessageModal extends Component {
  render() {
    let new_datestring = new Date(this.props.modal.timestamp).toLocaleString();
    return (
      <div
        className="modal fade"
        id="messageModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={this.props.modal.visible}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Message Sent on {new_datestring}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <h6>{this.props.modal.content}</h6>
            </div>
            <div className="modal-body">
              <h5 className="modal-title">Message Reception status:</h5>
              {this.props.modal.timestamp > 0 ? (
                <MessageConfirmations moment={this.props.modal.timestamp} />
              ) : (
                ""
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SentMessageModal;
